import { PropsWithChildren, ReactElement } from 'react'
import { Dropdown } from 'components/atoms/inputs/Select/Dropdown/Dropdown'
import { ItemPlain } from 'components/atoms/inputs/Select/ItemPlain/ItemPlain'
import { FitToHeight } from 'components/atoms/inputs/Select/FitToHeight/FitToHeight'
import Scrollable from 'components/atoms/Scrollable'
import { PreventScroll } from 'components/features/pfm/PreventScroll/PreventScroll'
import styles from 'components/atoms/inputs/Select/DropdownPreset/DropdownPreset.styl'
import { Select } from 'components/atoms/inputs/Select/parts/Select'

type DropdownPresetProps<Value> = {
  context: Select<Value>
}
export const DropdownPreset = <Value extends any>(props: PropsWithChildren<DropdownPresetProps<Value>>): ReactElement | null => {
  const { context } = props
  const { highlight, value, options, patchValue } = context

  return (
    <FitToHeight>
      <Dropdown className={ styles.dropdownPreset }>
        <Scrollable alwaysShowScrollbar flexBox>
          { options.map((item, index) => {
            const isHighlighted = highlight.index !== -1 ?
              highlight.index === index :
              value === item.value

            return (
              <ItemPlain
                key={ item.value as any }
                data-qa-type='dropdown-item'
                data-qa-marker={ item.value }
                highlighted={ !!isHighlighted }
                onMouseEnter={ () => highlight.setIndex(index) }
                onClick={ () => patchValue(item.value) }
              >
                { item.label }
              </ItemPlain>
            )
          })}
        </Scrollable>
        <PreventScroll />
      </Dropdown>
    </FitToHeight>
  )
}
